import { Component, Input, OnInit } from '@angular/core';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { OeAppService } from '../../shared/oe-app.service';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';

@Component({
  selector: 'lp2-news-carousel',
  templateUrl: './news-carousel.component.html',
  styleUrls: ['./news-carousel.component.scss'],
})
export class NewsCarouselComponent
  extends ImmersionCarouselComponent
  implements OnInit {
  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.newsPoints = value
      ? value.get(GamificationActivityType.COMPLETE_PRACTICE_NEWS)
      : 0;
  }

  newsPoints: number;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService,
    private oeAppService: OeAppService
  ) {
    super(service, levelProgressService, 'DAILY_NEWS');
  }

  ngOnInit() {
    this.extraParams = [
      { key: 'contactId', value: this.oeAppService.getPersonData().contactId },
    ];
    super.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/news-carousel/news-carousel.component.ts